// Load Styles
import '../../../scss/page/roojai/customer-reviews.scss';
import {utility, toggleScrollToSection} from '../../utility.js';

// Your app code
utility();

const masonry = document.querySelector('.reviews-masonry');

if (masonry) {
  const resizeItem = (item) => {
    const rowHeight = parseInt(
      getComputedStyle(masonry).getPropertyValue('grid-auto-rows'),
      10
    );

    const gap = parseInt(
      getComputedStyle(masonry).getPropertyValue('gap'),
      10
    );

    const card = item.firstElementChild;

    if (!card) return;

    const height = card.getBoundingClientRect().height;

    const span = Math.ceil((height + gap) / (rowHeight + gap));

    item.style.gridRowEnd = `span ${span}`;
  };

  const layout = () => {
    masonry.querySelectorAll('.masonry-item').forEach(resizeItem);
  };

  // Initial layout
  window.addEventListener('load', layout);

  // Responsive recalculation
  window.addEventListener('resize', layout);

  // Recalculate if content changes
  const observer = new ResizeObserver(layout);

  masonry.querySelectorAll('.masonry-item > *').forEach((el) => {
    observer.observe(el);
  });
}